import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAdmin } from '../hooks/useAdmin';
import PageSpinner from './PageSpinner';

// ── ADMIN-ONLY ROUTES ────────────────────────────────────────────────────────
// Stricter than ProtectedRoute, and separate from it on purpose: that one asks
// "are you signed in", this one asks "does your token carry the admin claim".
//
// WHAT IT IS NOT. This is not the security boundary — a determined visitor can
// render any component they like in their own browser. The boundary is
// firestore.rules and the claim check inside every admin callable, both of
// which run on Google's servers. This exists so an ordinary user never sees a
// broken page full of permission errors, and so the admin area is not
// advertised by a route that half-loads.
//
// A NON-ADMIN IS SENT TO THE DASHBOARD, not shown "access denied". Telling
// someone that a page exists but is barred from them is an invitation; the
// admin area is better off simply not appearing to exist.
export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  const { isAdmin, checking } = useAdmin();
  const location = useLocation();

  // Signed out entirely: send them to sign in and come back, which is the
  // ordinary protected-route behaviour and the one case where saying "you need
  // to be signed in" gives nothing away.
  if (!loading && !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // The claim answer is still in flight. NOT the same as "no" — see useAdmin.
  if (loading || checking) return <PageSpinner />;

  if (!isAdmin) return <Navigate to="/dashboard" replace />;

  return children;
}
